import React, { Component } from "react";
import firebase from "firebase";
import 'antd/dist/antd.css';
import { Redirect } from 'react-router-dom';
import { Alert, Icon, message, Button, Row } from 'antd';
// Component for Firebase Image Upload , which prints URL in console log for now

let search_url = "https://in.pinterest.com/search/pins/?q=";

const btnStyle =  {
  height: '50px',
  width: '60%',
}

export default class UploadImageAndSearch extends Component {
    constructor(){
      super();
      this.state = {
          file: "",
          imagePreviewUrl: ""
      };
      //Firebase Web Initialisation
      var config = {
          apiKey: "AIzaSyBIEekTPeEhZHeXhIrspDVZX2u2H2mhxoI",
          authDomain: "gt-imageupload.firebaseapp.com",
          databaseURL: "https://gt-imageupload.firebaseio.com",
          projectId: "gt-imageupload",
          storageBucket: "gt-imageupload.appspot.com",
          messagingSenderId: "1026634327180"
        };
    
        if (!firebase.apps.length) {
          firebase.initializeApp(config);
        }
}

  _handleSubmit(e) {
    console.log('handlesubmit was called');
    if(document.getElementById("fileToBeUploaded").value === "") {
      message.warning('File was not selected. Please select a file!');
      return;
   }
   console.log('if this appears, it is still executing');
    // e.preventDefault();
    // TODO: do something with -> this.state.file
    const ref = firebase.storage().ref();
    const file = this.state.file;
    const name = +new Date() + "-" + file.name;
    const metadata = {
      contentType: file.type
    };
    const task = ref.child(name).put(file, metadata);

    task.then(snapshot => {
        const url = snapshot.downloadURL;
        //Below line prints the url of uploaded image.
        this.setState({
          imagePreviewUrl: url.toString(),
        });
        console.log(url.toString());
        message.success("Image upload successful!");
        
        //api which identifies clothing in image
        var request = require("request");
        var options = { method: 'GET',
        url: 'https://api.mirrorthatlook.com/v2/classify',
        qs: { image: this.state.imagePreviewUrl },
        headers: 
        { 'ocp-apim-subscription-key': '21601658110c453d9d27200ef7ecbb83' } };

        request(options, function (error, response, body) {
        if (error) throw new Error(error);
      
        //console.log(body);
        var json = JSON.parse(body);
        var recognized_val_array = ' ';

        for( var i = 0; i< json.result.length; i++) 
          {
              console.log(json.result[i].label);
              recognized_val_array += json.result[i].label + ' ';
          };
        console.log(recognized_val_array);

        if(recognized_val_array === '')
        {
          message.error('Please upload image again! There was an error.');
        }
        else {
        let redirectWindow = window.open(
          search_url + recognized_val_array + " ",
          "_blank"
        );
        <Redirect to={redirectWindow} />
        }

        function fileDeleteOnTimer()  
        { //Function call to delete file right after the image upload was done and data was searched.
          var uploadedFileRef = ref.child(name);
          // Delete the file
          uploadedFileRef.delete().then(function() {
            console.log('File deleted successfully');
          }).catch(function(error) {
            // Uh-oh, an error occurred!
            console.log('nahi hui delete bro  '+JSON.stringify(error));
          });
        } 

        //File deletion from firebase begins after 60 seconds.
        setTimeout(fileDeleteOnTimer, 60000);
  }); 
        
        //This Below line shows the uploaded image on the bottom of the page. Different from Image preview.
        //document.querySelector("#afterupload").src = url;
        // Place this line in render if needed to show preview 
       // <img src="" height="50" width="50" id="afterupload" />
      }).catch(error => { console.error(error);   
      });
}

  _handleImageChange(e) {
    console.log('handleimagechange was called..');
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          this.setState({
            file: file,
          });
        };
      reader.readAsDataURL(file);
  }

render() {
        let { imagePreviewUrl } = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
        $imagePreview = <img height="150" width="150" src={imagePreviewUrl} alt="Uploaded_image_preview" />;
        }

    return (
    <div>  
    <Row type="flex" justify="center" style={{ paddingBottom: '5px'}}>
        <h4>Upload the image of your clothes and our <em>futuristic system</em> will analyse it and give you suggestions in a new tab of pinterest!</h4>
    </Row>
  <form onSubmit={e => this._handleSubmit(e)}>
    <Row type="flex" justify="center" style={{ paddingBottom: '10px', paddingTop: '5px'}}>
       <input
            className="fileInput"
            type="file"
            id="fileToBeUploaded"
            onChange={e => this._handleImageChange(e)}
          />
    </Row>
        <br />
    <Row type="flex" justify="center" style={{ paddingBottom: '10px', paddingTop: '5px'}}>
       <Button className="submitButton" size="large" style={btnStyle} type="primary" onClick={e => this._handleSubmit(e)}> <Icon type="upload" />Upload and Search!</Button>
    </Row> 
  </form>
    <Row type="flex" justify="center" style={{ paddingBottom: '10px', paddingTop: '10px'}}>
        <div className="imgPreview">{$imagePreview}</div>
    </Row>
    <Row type="flex" justify="center">
      <div>
        <Alert
          message='Privacy Notice'
          description='Your privacy is important and hence, the image uploaded gets deleted after 1 minute. '
          type="success"
          banner
        />
      </div>
    </Row>
    </div>
    );
  }
  
}


// WEBPACK FOOTER //
// ./src/uploadandsearch.js